export class Worker {
  constructor(public id: number = 0, public name: string = "") {}

  static fromObject(worker: any) {
    return new Worker(worker.id, worker.name);
  }
}
